import clsx from 'classnames'
import * as React from 'react'

import { isYearAndMonthViews, isYearOnlyView } from './_helpers/date-utils'
import { useUtils } from './_shared/hooks/useUtils'
import PickerToolbar from './_shared/PickerToolbar'
import ToolbarButton from './_shared/ToolbarButton'
import type { ToolbarComponentProps } from './Picker/Picker'

export const DatePickerToolbar: React.FunctionComponent<ToolbarComponentProps> = ({
  date,
  views,
  setOpenView,
  isLandscape,
  openView,
}) => {
  const utils = useUtils()

  const isYearOnly = React.useMemo(() => isYearOnlyView(views as any), [views])
  const isYearAndMonth = React.useMemo(() => isYearAndMonthViews(views as any), [views])

  return (
    <PickerToolbar
      isLandscape={isLandscape}
      className={clsx({
        'MuiPickersDatePickerRoot-toolbar': !isYearOnly,
        'MuiPickersDatePickerRoot-toolbarLandscape': isLandscape,
      })}
    >
      <ToolbarButton
        onClick={() => setOpenView('year')}
        selected={openView === 'year'}
        label={utils.getYearText(date)}
        className={clsx(isYearOnly ? 'mt-typography-h3' : 'mt-typography-subtitle1')}
      />

      {!isYearOnly && !isYearAndMonth && (
        <ToolbarButton
          selected={openView === 'date'}
          onClick={() => setOpenView('date')}
          align={isLandscape ? 'left' : 'center'}
          label={utils.getDatePickerHeaderText(date)}
          className={clsx({ 'MuiPickersDatePickerRoot-dateLandscape': isLandscape }, 'mt-typography-h4')}
        />
      )}

      {/* {isYearAndMonth && (
        <ToolbarButton
          onClick={() => setOpenView('month')}
          selected={openView === 'month'}
          label={utils.getMonthText(date)}
          className='mt-typography-h4'
        />
      )} */}
    </PickerToolbar>
  )
}
